export const messages = {
    deactivated:
        'Your visitation privileges have been revoked by the facility administrator. ' +
        'You cannot schedule visits at this facility at this time.',
    underage: 'This facility does not allow minors to schedule visits',
    iOS:
        "IOS (iPhone, iPad, iPod) devices must use Apple's Safari browser " +
        'to conduct their video visitation.',
    samsung:
        "Samsung A12 and A32 devices must use Mozilla's Firefox browser to " +
        'conduct their video visitation.',
    additionalVisit:
        'To get this promotional offer, you will need to add another visit. Please fill out the visit ' +
        'details in the same manner as before, starting with the inmate selection. ' +
        "After closing this dialog, simply select the 'Confirm Inmate' button if you want to visit the same inmate.",
    discountedVisit:
        'You have met the discount requirements. Please fill out your discounted visit details, ' +
        "starting with the inmate selection. After closing this dialog, simply select the 'Confirm Inmate' button " +
        'if you want to visit the same inmate.<b> Please note the following terms</b>:<br><br>' +
        '<ul class="text-left"><li>The discount will be applied during checkout.</li>' +
        '<li>You may only select an interval amount that is equal to or less than the <b>LOWEST</b> ' +
        'number of visit intervals previously selected in the disount offer.</li></ul>',
};
